"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateSurveyToSurveyCampaignMappingRequestToJSON = exports.CreateSurveyToSurveyCampaignMappingRequestFromJSONTyped = exports.CreateSurveyToSurveyCampaignMappingRequestFromJSON = exports.instanceOfCreateSurveyToSurveyCampaignMappingRequest = void 0;
/**
 * Check if a given object implements the CreateSurveyToSurveyCampaignMappingRequest interface.
 */
function instanceOfCreateSurveyToSurveyCampaignMappingRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "surveyCampaignId" in value;
    return isInstance;
}
exports.instanceOfCreateSurveyToSurveyCampaignMappingRequest = instanceOfCreateSurveyToSurveyCampaignMappingRequest;
function CreateSurveyToSurveyCampaignMappingRequestFromJSON(json) {
    return CreateSurveyToSurveyCampaignMappingRequestFromJSONTyped(json, false);
}
exports.CreateSurveyToSurveyCampaignMappingRequestFromJSON = CreateSurveyToSurveyCampaignMappingRequestFromJSON;
function CreateSurveyToSurveyCampaignMappingRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'surveyCampaignId': json['survey_campaign_id'],
    };
}
exports.CreateSurveyToSurveyCampaignMappingRequestFromJSONTyped = CreateSurveyToSurveyCampaignMappingRequestFromJSONTyped;
function CreateSurveyToSurveyCampaignMappingRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'survey_campaign_id': value.surveyCampaignId,
    };
}
exports.CreateSurveyToSurveyCampaignMappingRequestToJSON = CreateSurveyToSurveyCampaignMappingRequestToJSON;
